import { render, staticRenderFns } from "./radiolist.vue?vue&type=template&id=145f0627&scoped=true&"
import script from "./radiolist.vue?vue&type=script&lang=js&"
export * from "./radiolist.vue?vue&type=script&lang=js&"
import style0 from "./radiolist.vue?vue&type=style&index=0&id=145f0627&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f0627",
  null
  
)

export default component.exports